@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t">
  <div #widgetContainer class="widget-big-number__container" [class.hide]="isLoading">
    @if (dataSourceNotFound) {
      <div class="text-center">
        <h1>{{ t('widgets.data-source-removed-select-another') }}</h1>
      </div>
    } @else {
      @if (hasInvalidComparison) {
        <div class="widget-big-number__not-compatible kxi-text-large">
          <h1>{{ t('widgets.has-invalid-comparison') }}</h1>
        </div>
      } @else {
        @if (!displayEmptyState) {
          <ng-container
            *ngTemplateOutlet="tBigNumber; context: { field: fieldOne, fieldName: 'fieldOne' }"
          ></ng-container>

          @if (multipleFields) {
            <ng-container
              *ngTemplateOutlet="tBigNumber; context: { field: fieldTwo, fieldName: 'fieldTwo' }"
            ></ng-container>
          }
        } @else {
          <div class="margin-auto-0">
            <h1>
              {{ t('widgets.no-documents-found') }}
            </h1>
          </div>
        }
      }

      <ng-template #tBigNumber let-field="field" let-fieldName="fieldName">
        <div class="widget-big-number__content">
          @if (!!field.theBigNumber) {
            <div class="widget-big-number__average-wrapper">
              @if (insightPointSelectionState[fieldName].theBigNumber.selected) {
                <div>
                  <ng-container
                    *ngTemplateOutlet="
                      insightPointMarkup;
                      context: {
                        $implicit: insightPointSelectionState[fieldName].theBigNumber.index,
                      }
                    "
                  ></ng-container>
                </div>
              }
              <div
                (click)="
                  onInsightPointSelection({
                    field,
                    fieldState: insightPointSelectionState[fieldName],
                    valueName: 'theBigNumber',
                  })
                "
                class="widget-big-number__average"
                [class.widget-big-number__average--selectable]="insightPointSelectionState.active"
                [class.widget-big-number__average--disabled]="
                  insightPointSelectionState[fieldName].disabled
                "
                [matTooltip]="comparisonBucketNames"
              >
                {{
                  (field.theBigNumber | isValidNumber)
                    ? (field.theBigNumber
                      | humanizeInt: field.intPrecision : 1000 : field.intPrecision)
                    : t('widgets.n-a')
                }}
              </div>
            </div>
          }

          @if (
            (field.theBigNumber | isValidNumber) &&
            (hasFilters || widgetGroup?.isImpact || comparisonFilterCount > 1)
          ) {
            <div class="widget-big-number__diff-wrapper">
              @if (widgetGroup?.isImpact || comparisonFilterCount > 1) {
                @if (field.isPreviousPeriod0) {
                  <div class="widget-big-number__diff">
                    {{ t('widgets.previous-was-zero') }}
                  </div>
                } @else {
                  @if (!field.isVsPreviousNumberLoading) {
                    <div
                      class="widget-big-number__diff widget-big-number__comparison"
                      [class.widget-big-number__diff--selectable]="
                        insightPointSelectionState.active &&
                        !insightPointSelectionState[fieldName].theSmallNumber.disabled
                      "
                      [class.widget-big-number__diff--disabled]="
                        insightPointSelectionState[fieldName].disabled ||
                        insightPointSelectionState[fieldName].theSmallNumber.disabled
                      "
                      (click)="
                        onInsightPointSelection({
                          field,
                          fieldState: insightPointSelectionState[fieldName],
                          valueName: 'theSmallNumber',
                        })
                      "
                    >
                      <xi-icon
                        [icon]="
                          field.vsPreviousNumber > 0
                            ? 'small_up_triangle_filled'
                            : 'small_down_triangle_filled'
                        "
                        [color]="
                          field.vsPreviousNumber > 0
                            ? field.increaseArrowColor.color
                            : field.decreaseArrowColor.color
                        "
                        iconSize="xxlarge"
                      ></xi-icon>

                      @if (insightPointSelectionState[fieldName].theSmallNumber.selected) {
                        <div>
                          <div class="widget-big-number__insight-point-markup--small">
                            <ng-container
                              *ngTemplateOutlet="
                                insightPointMarkup;
                                context: {
                                  $implicit:
                                    insightPointSelectionState[fieldName].theSmallNumber.index,
                                }
                              "
                            ></ng-container>
                          </div>
                        </div>
                      }
                      <span>
                        {{
                          (field.vsPreviousNumber | isValidNumber)
                            ? field.displayDataAs === 'absolute'
                              ? (field.vsPreviousNumber
                                | number: '1.' + field.intPrecision + '-' + field.intPrecision)
                              : (field.vsPreviousNumber
                                | percent: '1.' + field.intPrecision + '-' + field.intPrecision)
                            : t('widgets.previous-was-zero')
                        }}
                      </span>
                    </div>
                  } @else {
                    <ng-container *ngTemplateOutlet="numbersLoading"></ng-container>
                  }
                }
              }
            </div>
          }

          @if (field.showDisplayName !== false) {
            <div class="widget-big-number__display-name">
              {{ field.analyticItemDisplayName }}
            </div>
          }
        </div>

        <ng-template #insightPointMarkup let-index>
          <div class="widget-big-number__insight-point-markup">
            <xi-icon icon="lightbulb" iconSize="small" color="CX"></xi-icon>

            <span>{{ index }}</span>
          </div>
        </ng-template>
      </ng-template>

      <ng-template #numbersLoading>
        <div class="widget-big-number__diff widget-big-number__numbers-loading">
          <xi-animation
            [height]="24"
            [width]="24"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      </ng-template>
    }
  </div>
</ng-container>
